import clientLogger from 'shared/utils/clientLogger';
export const adobeTargetDataLayer = (window as any).adobeDataLayer ?? [];

export const trackLoadTime = (startTime: number, endTime: number, sagaName: string, flowId: string): void => {
  if (startTime < endTime && startTime != 0) {
    adobeTargetDataLayer.push({ event: 'loadTime', seconds: (endTime - startTime) / 1000 });
  } else {
    clientLogger(`startTime:${startTime} endTime:${endTime}`, 'Invalid start or end time.');
  }
};
